import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FiMessageSquare } from 'react-icons/fi';

const TestimonialCard = ({ testimonial }) => {
  return (
    <CardContainer
      whileHover={{ y: -5 }}
      transition={{ duration: 0.3 }}
    >
      <QuoteIcon>
        <FiMessageSquare />
      </QuoteIcon>
      <CardContent>
        <TestimonialText>"{testimonial.content}"</TestimonialText>
        <TestimonialAuthor>
          <AuthorAvatar>
            <img src={testimonial.avatar} alt={testimonial.name} />
          </AuthorAvatar>
          <AuthorInfo>
            <AuthorName>{testimonial.name}</AuthorName>
            <AuthorPosition>{testimonial.position}</AuthorPosition>
          </AuthorInfo>
        </TestimonialAuthor>
      </CardContent>
    </CardContainer>
  );
};

const CardContainer = styled(motion.div)`
  position: relative;
  padding: 2rem;
  border-radius: var(--border-radius);
  height: 100%;
  
  .light & {
    background-color: var(--bg-primary-light);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  
  .dark & {
    background-color: var(--bg-secondary-dark);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  }
`;

const QuoteIcon = styled.div`
  position: absolute;
  top: -15px;
  left: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  
  .light & {
    background: linear-gradient(135deg, var(--primary-light), var(--secondary-light));
    color: white;
  }
  
  .dark & {
    background: linear-gradient(135deg, var(--primary-dark), var(--secondary-dark));
    color: var(--bg-primary-dark);
  }
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const TestimonialText = styled.p`
  font-style: italic;
  margin-bottom: 1.5rem;
  flex: 1;
  
  .light & {
    color: var(--text-secondary-light);
  }
  
  .dark & {
    color: var(--text-secondary-dark);
  }
`;

const TestimonialAuthor = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: auto;
`;

const AuthorAvatar = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const AuthorInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const AuthorName = styled.h4`
  font-size: 1rem;
  margin-bottom: 0.25rem;
  
  .light & {
    color: var(--text-primary-light);
  }
  
  .dark & {
    color: var(--text-primary-dark);
  }
`;

const AuthorPosition = styled.p`
  font-size: 0.9rem;
  margin: 0;
  
  .light & {
    color: var(--text-secondary-light);
  }
  
  .dark & {
    color: var(--text-secondary-dark);
  }
`;

export default TestimonialCard;